import axios from 'axios'

export default {
  data() {
    return {
      isLoading: false,
      error: false,
      data: null,
      response: null,
    }
  },
  methods: {
    callAxios(config) {
      this.isLoading = true
      this.error = false

      const axiosIns = axios.create({
        // eslint-disable-next-line prefer-template
        baseURL: argus_url.rest + 'wp/v2/',
      })

      axiosIns(config)
        .then(res => {
          this.response = res
          this.data = this.response.data
        })
        .catch(err => {
          this.error = err.response?.data.errors ?? err.message
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
